import { ApiBaseService, ApiV2Service } from './api.base.service';
import store from '@/store/store';

export interface Counts {
  projects: number;
  tasks: number;
  catalogue: number;
  devices: number;
  sites: number;
  users: number;
  gateways: number;
}

export class ReportingService {
  private api: ApiBaseService;

  constructor() {
    this.api = ApiV2Service;
  }

  public async getOrganisationCounts(): Promise<Counts> {
    const organisation = store.getters.activeOrganisationId;
    return this.api.get(`reporting/${organisation}/counts`);
  }

  public async getProjectCounts(): Promise<Counts> {
    const organisation = store.getters.activeOrganisationId;
    const project = store.getters.activeProjectId;
    return this.api.get(`reporting/${organisation}/${project}/counts`);
  }

  public async getSystemSummary(monthFilter: string = ''): Promise<any> {
    let queryString: string = '';
    if (monthFilter && monthFilter.length) {
      queryString = `?timePeriod=${monthFilter}`;
    }
    return this.api.get(`reporting/system/summary/${queryString}`);
  }

}

export default new ReportingService();
